import { BaSeTheme } from '@base/react';
import styled, { css } from 'styled-components';

const handleQuery = (style) => {
  return `
    ${BaSeTheme.breakpoints.tablet.mediaQueryCss(style)};
    ${BaSeTheme.breakpoints.mobileLarge.mediaQueryCss(style)};
    ${BaSeTheme.breakpoints.mobile.mediaQueryCss(style)};
    ${BaSeTheme.breakpoints.mobileSmall.mediaQueryCss(style)};
  `;
};

export const ContainerAboutCourse = styled.div`
  display: flex;
  justify-content: center;
  width: 100vw;
  min-height: 100vh;
  ${({ empretecGraphics }) => css`
    background: url(${empretecGraphics}) no-repeat center/180%;
  `}
  ${handleQuery(css`
    background: none;
  `)}
`;
